app.controller('settingsTemplateEditController', ['$scope', '$state', '$stateParams', 'objectHelper', 'applicationModel', 'mainModel', 'templateModel', 'userModel',
    function ($scope, $state, $stateParams, objectHelper, applicationModel, mainModel, templateModel, userModel) {

        var listeners = {};


        function addNewDiagnosisToList(icd10) {
            var newDiagnosis = new DiagnosisVO();
            newDiagnosis.icd10 = icd10;
            newDiagnosis.mainAffliction = $scope.template.diagnosisList.length === 0;
            $scope.template.diagnosisList.push(newDiagnosis);
        }

        function addNewMedicalProcedureToList(icd9) {
            var newMedicalProcedure = new MedicalProcedureVO();
            newMedicalProcedure.icd9 = icd9;
            newMedicalProcedure.date = new Date();
            newMedicalProcedure.times = 1;
            $scope.template.medicalProcedures.push(newMedicalProcedure);
        }

        function addNewOTCDrugToList(drug) {
            var localOtcDrug = {
                otcDrug: new PrescribedDrugVO(),
                packages: null
            };
            localOtcDrug.otcDrug.drug = new DrugVO();
            localOtcDrug.otcDrug.drug.name = drug.name;
            localOtcDrug.otcDrug.drug.commonName = drug.commonName;
            localOtcDrug.otcDrug.drug.form = drug.form;
            localOtcDrug.otcDrug.drug.strength = drug.strength;
            localOtcDrug.otcDrug.count = 1;
            localOtcDrug.packages = drug.packages.map(function (p) {
                return p.drugPackage;
            });
            localOtcDrug.otcDrug.drug.packing = localOtcDrug.packages[0];
            $scope.localOtcDrugs.push(localOtcDrug);
        }

        function setData() {
            $scope.template = null;
            $scope.localOtcDrugs = [];

            $scope.forms = {
                templateEdit: null
            };
            $scope.hideAddButton();
            $scope.showBackButton();
            $scope.setTitle('T.MODULE.TEMPLATES.EDIT_TEMPLATE');

        }

        function setPermissions() {
        }

        function setListeners() {

            $scope.$watch('newDiagnosis', function(newVal, oldVal) {
                if(!_.isUndefined(newVal) && newVal != null) {
                    addNewDiagnosisToList(newVal);
                    $scope.newDiagnosis = undefined;
                }
            });

            $scope.$watch('newMedicalProcedure', function(newVal, oldVal) {
                if(!_.isUndefined(newVal) && newVal != null) {
                    addNewMedicalProcedureToList(newVal);
                    $scope.newMedicalProcedure = undefined;
                }
            });

            $scope.$watch('newOtcDrug', function(newVal, oldVal) {
                if(!_.isUndefined(newVal) && newVal != null) {
                    addNewOTCDrugToList(newVal);
                    $scope.newOtcDrug = undefined;
                }
            });

            listeners.onGetTemplateById = function (template) {
                $scope.template = template;
                $scope.previewOnly = ($scope.template.user.id != userModel.currentUser.id);
                $scope.localOtcDrugs = [];
                $scope.template.prescribedDrugs.forEach(function (otcDrug) {
                    $scope.localOtcDrugs.push({otcDrug: otcDrug, packages: [otcDrug.drug.packing], noPackages: true});
                });
            };
        }

        function setActions() {

            $scope.save = function () {
                $scope.forms.templateEdit.$setSubmitted();
                if($scope.forms.templateEdit.$valid) {
                    templateModel.update($scope.template).then(function (newTemplate) {
                        $state.go(Constant.STATE.APP.MEEDY.SETTINGS.TEMPLATE.LIST);
                    });
                }
            };
        }

        function configureInterface() {

        }

        function initialize() {
            templateModel.getById($stateParams.templateId).then(function (template) {
                listeners.onGetTemplateById(template);
            });
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
